<template>
    <div class="suite_manage_wrap">
        <div class="header">
            <el-button size="medium" type="primary" @click="toAddSuite"
                       v-if="isShowByPermission('/wyms/suite/addSuite')">新建套件
            </el-button>
            <el-radio-group v-model="suiteType" size="medium" style="margin-left: 10px;">
                <el-radio-button label="1">通用</el-radio-button>
                <el-radio-button label="2">微校+</el-radio-button>
                <el-radio-button label="3">成长乐园</el-radio-button>
            </el-radio-group>
        </div>
        <div class="suite_list_box" :style="`height: ${windowHeight - 170}px;`">
            <div class="suite_list" v-if="dataList && dataList.length">
                <div class="suite_line_box" :key="item.suiteGroups" v-for="item in dataList">
                    <div class="suite_title">{{suiteGroupList[item.suiteGroups - 1] || '其他'}}</div>
                    <div class="suite_box">
                        <div class="suite_item" :key="suiteIndex" v-for="(suiteItem, suiteIndex) in item.suiteList">
                            <img class="suite_logo_img" :src="suiteItem.logoUrl">
                            <div class="suite_title_wrap">
                                <h2>{{suiteItem.name}}</h2>
                                <div class="suite_tag">{{suiteTypeList[suiteItem.suiteType - 1] || '其他'}}</div>
                                <div class="suite_id">{{suiteItem.suiteId}}</div>
                                <div class="operation_wrap">
                                    <span @click="toSuiteInfo(suiteItem.id)"
                                          v-if="isShowByPermission('/wyms/suite/detailZ')">查看</span>
                                    <span @click="toInstallSuite(suiteItem)"
                                          v-if="isShowByPermission('/wyms/suite/install')">安装</span>
                                </div>
                            </div>
                            <div class="build_status has_send" v-if="suiteItem.authType === 0">已发布</div>
                            <div class="build_status" v-else>测试中</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no_stu_msg" v-else>
                <img
                    src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
                    alt="">
                <div>暂无套件</div>
            </div>
        </div>
        <el-dialog
            title="套件二维码"
            :visible.sync="isShowQrcode"
            :close-on-press-escape='false'
            width="300px"
            :lock-scroll="false"
            :close-on-click-modal='false'
            :modal-append-to-body='false'
        >
            <div class="qrcode-container">
                <img class="qrcode" :src="currentQrcode" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize'
    import {getSuiteList, suiteInstall} from '@/api/suiteSystem'

    export default {
        name: "suiteManageIndex",
        data() {
            return {
                suiteType: 0,
                suiteGroupList: ['通讯录套件', '基础套件', '独立应用', '行业应用'],
                suiteTypeList: ['应用套件', '通讯录套件', '普通应用', '通讯录应用', '其他', '家校应用'],
                allDataList: [],
                dataList: [],
                currentQrcode: '',
                isShowQrcode: false
            }
        },
        mixins: [windowResize],
        watch: {
            suiteType(val) {
                this.dataList = [];
                let suiteGroupList = [];
                this.allDataList.forEach((item) => {
                    if (item.suiteEnvironment === Number(val)) {
                        if (suiteGroupList.indexOf(item.suiteGroups) > -1) {
                            const groupIndex = suiteGroupList.indexOf(item.suiteGroups);
                            this.dataList[groupIndex].suiteList.push(item)
                        } else {
                            suiteGroupList.push(item.suiteGroups);
                            this.dataList.push({
                                suiteGroups: item.suiteGroups,
                                suiteList: [item]
                            })
                        }
                    }
                })
            }
        },
        created() {
            this.getSuiteList()
        },
        methods: {
            isShowByPermission,
            toAddSuite() {
                this.$router.push({path: 'suiteManageAdd'})
            },
            toSuiteInfo(suiteId) {
                this.$router.push({path: 'suiteManageInfo', query: {suiteId: suiteId}})
            },
            getSuiteList() {
                getSuiteList().then(data => {
                    this.allDataList = data;
                    this.suiteType = 1;
                })
            },
            toInstallSuite(item) {
                if(item.suiteQrCodeUrl) {
                    this.currentQrcode = item.suiteQrCodeUrl;
                    this.isShowQrcode = true;
                } else {
                    suiteInstall({id: item.id}).then(data => {
                        window.open(data, '_blank');
                    })
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../../styles/mixin';

    .suite_manage_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .suite_list_box {
            @include scrollBar;

            .suite_list {
                .suite_line_box {
                    overflow: hidden;

                    .suite_title {
                        height: 20px;
                        line-height: 20px;
                        margin-top: 15px;
                        margin-left: 15px;
                        padding-left: 8px;
                        border-left: 4px solid #409EFF;
                        font-weight: bold;
                    }

                    .suite_box {
                        padding-bottom: 20px;
                        overflow: hidden;

                        .suite_item {
                            @include clearfix;
                            position: relative;
                            height: 150px;
                            margin-top: 20px;
                            margin-left: 20px;
                            padding: 10px;
                            box-sizing: border-box;
                            float: left;
                            overflow: hidden;
                            border-radius: 5px;
                            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
                            transition: all .2s linear;

                            &:hover {
                                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                                transform: translate3d(0, -2px, 0);
                            }

                            .suite_logo_img {
                                float: left;
                                width: 90px;
                                height: 90px;
                                margin: 20px 15px 20px 5px;
                                border-radius: 4px;
                            }

                            .suite_title_wrap {
                                float: left;
                                width: 165px;
                                height: 125px;

                                h2 {
                                    font-size: 16px;
                                    font-weight: bold;
                                    width: 100%;
                                    max-height: 42px;
                                    word-wrap: break-word;
                                    word-break: break-all;
                                    overflow: hidden;
                                }

                                .suite_tag {
                                    padding: 5px 15px;
                                    background: #e5e5e5;
                                    text-align: center;
                                    display: inline-block;
                                    line-height: 20px;
                                }
                                .suite_id {
                                    margin-top: 5px;
                                }

                                .operation_wrap {
                                    font-size: 16px;
                                    margin-top: 5px;

                                    span {
                                        margin-right: 5px;
                                        color: #409EFF;
                                        cursor: pointer;
                                    }
                                }
                            }

                            .build_status {
                                position: absolute;
                                top: 10px;
                                right: -20px;
                                width: 80px;
                                height: 20px;
                                font-size: 14px;
                                line-height: 20px;
                                text-align: center;
                                color: #fff;
                                background: #409eff;
                                transform: rotate(45deg);
                            }

                            .has_send {
                                background: #f56c6c;
                            }
                        }
                    }
                }
            }

            .no_stu_msg {
                text-align: center;
                font-size: 15px;
                color: #999;
                overflow: hidden;

                img {
                    display: block;
                    margin: 30px auto 0;
                }

                div {
                    height: 20px;
                    line-height: 20px;
                    margin-top: -40px;
                }
            }
        }
        .qrcode {
            width: 200px;
            height: 200px;
        }
        .qrcode-container {
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/suiteSystem/suiteManage/suiteManageIndex.vue